import {api} from '../components/Base/App';

export default {
    getReviews() {
        return api({
            method: 'get',
            url: '/rest/reviews'
        });
    }
}



// WEBPACK FOOTER //
// ./src/api/Reviews.js